import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Card } from "./card";
import { useMediaQuery } from "react-responsive";



const image = [
  {
    icon: "assets/images/keindia/bsc.png",
  },
  {
    icon: "assets/images/keindia/levis.png",
  },
  {
    icon: "assets/images/keindia/libas.png",
  },
  {
    icon: "assets/images/keindia/foxtale.png",
  },
  {
    icon: "assets/images/keindia/rabbit.png",
  },
];

export const SectionTwo = () => {
  const scrollToTop = () => {
    const isMobileOrTablet = window.innerWidth <= 991;
    window.scrollTo({
      top: isMobileOrTablet ? 350 : 100,
      behavior: "smooth",
    });
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="section-2a-Ind">
      <div className="container-fluid">
        <div className="top-text">
          <h1>Powering 3,000+ eCommerce Brands</h1>

        </div>
        <div
          className="d-flex flex-wrap justify-content-center align-items-center"
          style={{ margin: "50px 0 80px 0", gap: !isMobile ? "145px" : "60px" }}
        >
          {image.map((data, ind) => {
            const isFoxtale = data.icon.includes("foxtale.png");
            const isRabbit = data.icon.includes("rabbit.png");
            const isLarge = isFoxtale || isRabbit;
            return (
              <div
                key={ind}
                style={{
                  maxWidth: isLarge ? "200px" : "150px", // Increased width for studio
                  minWidth: isLarge ? "80px" : "60px",
                  color: "white",
                }}
              >
                <img
                  src={data.icon}
                  alt={`Brand ${ind}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>


    </div>
  );
};
